import React, { useState, Fragment, useEffect } from 'react';
import { useSelector, useDispatch } from "react-redux";
import { useTranslation } from 'react-i18next';
import moment from 'moment';
import {
  Tabs,
  Tab,
  makeStyles,
  TableCell,
  IconButton,
} from "@material-ui/core";
import ViewIcon from '@material-ui/icons/Visibility';
import config from '../../config';
import { history } from '../../helpers';
import { useWindowSize } from '../../hooks';
import { reportActions } from "./../../actions";
import { tableCss } from './../../components/Tables/TableCss';
import { GraphicPanel, PieChartImagine } from "./../../components";
import { TablePanel, ReportCards, ReportLayout } from "./../../components";

const useStyles = makeStyles((theme) => ({
  tab: {
    width: "50%",
    maxWidth: "unset",
    backgroundColor: theme.palette.neutrals.high.main,
  },
  tabs: {
    border: `1px solid ${theme.palette.grey.main}`,
    borderRadius: 8, 
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 0,
  }
}))

export const ReportStatusIdea = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const tableClasses = tableCss();
  const [arrItensCard, setArrItensCArd] = useState({
    cardContent: [],
    dialogContent: []
  })
  const [width] = useWindowSize();
  const { 
    tab,
    report, 
    chart,
  } = useSelector(state => state.report);
  const { t } = useTranslation();
  const [tabIndex, setTabIndex] = useState(0);
  function formatBRL(value) {
    return new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' })
      .format(parseFloat(value).toFixed(2))
  }

  const tableInfo = {
    columns: [
      { id: "code", label: t('codigo') },
      { id: 'nomeautor', label: t("autor")},
      { id: 'aprovador', label: t("aprovador")},
      { id: 'email', label: t("email")},
      { id: 'ideaName', label: t('nome_da_ideia') },
      { id: 'status', label: t('status') },
      { id: 'local', label: t('local') },
      { id: 'area', label: t('area') },
      { id: 'tipoAmbito', label: t('tipo_ambito') },
      { id: 'date', label: t('data')  + ' ' + t('inicio') },
      { id: 'conclusionDate', label:t('data') + ' ' + t('termino') },
      { id: "challenge", label: t('desafio') },
      { id: "retorno_estimado", label: t("retorno_estimado")},
      { id: "retorno_real", label: t("retorno_real")},
      { id: "custo_estimado", label: t("custo_estimado")},
      { id: "custo_real", label: t("custo_real")},
      { id: 'link', label: t('link') },
    ],
    data: report.map(item => (
      <Fragment>
        <TableCell classes={{ root: tableClasses.tableCell }}>{item.code || ""}</TableCell>
        <TableCell classes={{ root: tableClasses.tableCell }}>{item.userName || ""}</TableCell>
        <TableCell classes={{ root: tableClasses.tableCell }}>{item.approver && item.approver.length > 0 ? item.approver[0].name : ""}</TableCell>
        <TableCell classes={{ root: tableClasses.tableCell }}>{item.approver && item.approver.length > 0 ? item.approver[0].email : ""}</TableCell>
        <TableCell classes={{ root: tableClasses.tableCell }}>{item.name}</TableCell>
        <TableCell classes={{ root: tableClasses.tableCell }}>{item.statusIdea?.name}</TableCell>
        <TableCell classes={{ root: tableClasses.tableCell }}>{item.businessUnitLocal?.length > 0 ? item.businessUnitLocal[0]?.local?.name : ""}</TableCell>
        <TableCell classes={{ root: tableClasses.tableCell }}>{item.businessUnitLocal?.length > 0 ? item.businessUnitLocal[0]?.occupationArea?.name : ""}</TableCell>
        <TableCell classes={{ root: tableClasses.tableCell }}>{item.methodology?.name}</TableCell>
        <TableCell classes={{ root: tableClasses.tableCell }}>{`${moment(item.createdAt).format('DD/MM/YYYY')}`}</TableCell>
        <TableCell classes={{ root: tableClasses.tableCell }}>{ item?.conclusionDate ?`${moment(item?.conclusionDate).format('DD/MM/YYYY')}`: ''}</TableCell>
        <TableCell classes={{ root: tableClasses.tableCell }}>{item.challenge?.name || ""}</TableCell>
        <TableCell classes={{ root: tableClasses.tableCell }}>{formatBRL(item.retornoEstimado)}</TableCell>
        <TableCell classes={{ root: tableClasses.tableCell }}>{formatBRL(item.retornoReal)}</TableCell>
        <TableCell classes={{ root: tableClasses.tableCell }}>{formatBRL(item.custoEstimado)}</TableCell>
        <TableCell classes={{ root: tableClasses.tableCell }}>{formatBRL(item.custoReal)}</TableCell>
        <TableCell classes={{ root: tableClasses.tableCell }}>
          <IconButton onClick={() => {history.push(`/idea/${item._id}/general`)}}>
            <ViewIcon />
          </IconButton>
        </TableCell>
      </Fragment>
    )),
  }

  useEffect(() => {
    setArrItensCArd({
      cardContent: report.map(item => (
        [
          {
            name: "nome da ideia",
            value: item.name,
          },
          {
            name: "status",
            value: item.statusIdea?.name
          },
          {
            name: "local",
            value: item.businessUnitLocal?.length > 0 ? item.businessUnitLocal[0]?.local?.name : ""
          }
        ]
      )),
      dialogContent: report.map(item => (
        [
          {
            name: "code",
            value: item.code,
          },
          {
            name: t("autor"),
            value: item.userName,
          },
          {
            name: t("aprovador"),
            value: item.approver && item.approver.length > 0 ? item.approver[0].name : "",
          },
          {
            name: t("email"),
            value: item.approver && item.approver.length > 0 ? item.approver[0].email : "",
          },
          {
            name: "nome da idéia",
            value: item.name,
          },
          {
            name: "status",
            value: item.statusIdea?.name
          },
          {
            name: "local",
            value: item.businessUnitLocal?.length > 0 ? item.businessUnitLocal[0]?.local?.name : ""
          },
          {
            name: "area",
            value: item.businessUnitLocal?.length > 0 ? item.businessUnitLocal[0]?.occupationArea?.name : ""
          },
          {
            name: "data",
            value:  moment(item.createAt).format('DD/MM/YYYY')
          },
          {
            name: "tipo / âmbito",
            value: item.methodology?.name
          },
          {
            name: "data de conclusão",
            value: moment(item?.conclusionDate).format('DD/MM/YYYY')
          },
          {
            name: t("desafio"),
            value: item.challenge?.name,
          },
          {
            name: t("retorno_estimado"),
            value: item.retornoEstimado,
          },
          {
            name: t("retorno_real"),
            value: item.retornoReal,
          },
          {
            name: t("custo_estimado"),
            value: item.custoEstimado,
          },
          {
            name: t("custo_real"),
            value: item.custoReal,
          },
          {
            name: t("link"),
          },
        ]
      ))
    })
  }, [report])

  useEffect(() => {
    return () => {
      dispatch(reportActions.clearAll())
    }
  }, [dispatch])

  function handleChangeTab(index) {
    dispatch(reportActions.changeTab(index === 0 ? "table" : "graph"));
    setTabIndex(index)
  }
  
  return (
    <ReportLayout title={t('status_das_ideias')}>
      <Tabs className={classes.tabs} value={tabIndex} onChange={(e, value) => handleChangeTab(value)} aria-label="Tabs de grafico e tabela" indicatorColor="primary">
        <Tab className={classes.tab} label={t('tabela')} aria-controls="Panel tabela" />
        <Tab className={classes.tab} label={t('grafico')} aria-controls="Panel grafico" />
      </Tabs>

      { tab === "table" && (
        <Fragment>
          { width > config.RESPONSIVE_MOBILE ?  
            <TablePanel tableInfo={tableInfo} /> : 
            <ReportCards arrItems={arrItensCard} /> 
          }
        </Fragment>
      )}

      { tab === "graph" && (
        <GraphicPanel>
          <PieChartImagine data={chart} />
        </GraphicPanel>
      )}
    </ReportLayout>
  )
}
